import { environment } from "@/environments/environment";

const env = {
  // isNative: typeof window !== 'object',
  // platform: weex.config.env.platform,
  // deviceWidth: weex.config.env.deviceWidth,
  // deviceHeight: weex.config.env.deviceHeight,

  get baseUrl() {
    let url;
    // let bundleUrl = weex.config.bundleUrl;
    // let isAndroid = bundleUrl.indexOf('file://assets/') > -1;
    // let isiOS = bundleUrl.indexOf('file:///') > -1;
    let bundleUrl = ""
    let isAndroid = false;
    let isiOS = false;

    if (isAndroid) {
      url = 'file://assets/dist/'
    } else if (isiOS) {
      url = bundleUrl.substring(0, bundleUrl.lastIndexOf('/') + 1)
    } else {
      let host = 'localhost:9081';
      let matches = /\/\/([^\/]+?)\//.exec(bundleUrl);
      host = (matches && matches.length >= 2) ? matches[1] : host;
      url = `${environment.webProtocol}://${host}/`;
    }

    return url
  },

  isAndroidPlatform() {
    // return this.platform.toUpperCase() === "Android".toUpperCase();
    return false;
  },
  isIOSPlatform() {
    // return this.platform.toUpperCase() === "iOS".toUpperCase();
    return false;
  },
  isWebPlatform() {
    return !this.isAndroidPlatform() && !this.isIOSPlatform();
  }
};

export default env
